export const VehicleAndLicenseTextdata = 
  {
    vehicleTypeL: {
        headingText:
        "Vehicle Category L",
        headingText2:
        "Two, Three, and Four-Wheeled Bikes, Tricycles, and Quadricycles",
        subHeading:
        "Explore a comprehensive range of courses for obtaining a motorcycle and limited-speed vehicle license under Ontario's licensing system.",
        headingForListing:
        "Vehicle Category Covered in Class L: Two, Three, and Four-Wheeled Bikes, Tricycles, and Quadricycles",
        subHeadingForListing:
        "Licence Classes Covered: M1, M2, and M full, M2 with L Condition M2 with 1 Condition",
    },
    vehicleTypeM: {
      headingText:
        "Vehicle Category M                               ",
      headingText2:
        "Vehicle Learning Innovation – Your Path to a Full Class G Licence",
      subHeading:
        "Master the fundamentals of driving with these expert-guided courses and knowledge tests for Ontario’s G1, G2, and G licenses through Govt. Approved training institutions.",
        headingForListing:
        "Vehicle Category M – Personal Passenger Vehicles",
        subHeadingForListing:
        "Licence Classes Covered: G1, G2, and G",
    },
    vehicleTyeN: {
        headingText:
        "Vehicle Category N",
        headingText2:
        "Vehicle Learning Innovation – Commercial Driving Courses for Material and Goods Transportation",
        subHeading:
        "Prepare for a successful career in commercial driving with these specialized courses and knowledge tests.",
        headingForListing:
        "Vehicle Category N – Commercial Vehicles for Material Transportation",
        subHeadingForListing:
        "Licence Classes Covered: A, B, C, D, E, and F",

    },
    vehicleTypeT: {
        headingText: "Vehicle Category T",
        headingText2:
        "Agriculture and Construction Machinery",
        subHeading:
        "Operate heavy-duty equipment with confidence and safety! These courses provide essential training to obtain licenses for tractors, forklifts, cranes, and earth-moving machinery under Ontario law and regulation with MOT approved training institutions.",
        headingForListing:
        "Vehicle Category T – Agriculture and Construction Machinery",
        subHeadingForListing:
        "Licence Classes Covered: G, D, and Az",
    },
    vehicleTypeAmbulance: {
      headingText: "Vehicle Category  – Ambulance",
      headingText2:
      "",
      subHeading:
      "Emergency medical vehicles designed for safe and rapid patient transportation to healthcare facilities. Our training ensures you master the operation of ambulances, complying with Ontario, Canada’s licensing regulations for emergency vehicle drivers.",
      headingForListing:
      "License Classes Covered in This Category (Ontario, Canada)",
      subHeadingForListing:
      "Licence Classes Covered: C, and F",
    },
    vehicleTypeSchoolBus: {
      headingText: "Vehicle Category  – School Bus",
      headingText2:
      "",
      subHeading:
      "Buses built for the safe and comfortable transportation of students to and from school, following strict safety regulations in Ontario, Canada. Our program prepares drivers to handle school buses with precision and care.",
      headingForListing:
      "License Classes Covered in This Category (Ontario, Canada):",
      subHeadingForListing:
      "Licence Classes Covered: B, and E",
    },
    vehicleTypeB: {
      headingText: "Class B License",
      headingText2:
        "Drive with Confidence and Responsibility Become a Certified School Bus Driver with Expert Training",
      subHeading:
      "At Vehicle Learning Innovation, We help you find the best training institutes to ensure you pass your Class B tests with ease.",
      headingForListing:
      "Class B License",
      subHeadingForListing:
      "Authorizes you to drive school buses carrying more than 24 passengers, as well as any vehicle covered under a Class E license. To qualify, you must pass a written knowledge test, complete a vision screening, and demonstrate your driving skills in a road test.",
    },
    vehicleTypeD: {
      headingText: "Class D License",
      headingText2:
        "Drive Heavy Vehicles with Confidence. Step Up to Professional Driving with a Class D License.",
      subHeading:
      "Looking to drive commercial trucks and expand your career opportunities? Vehicle Learning Innovation connects you with trusted, MOT-approved training institutes that prepare you for the Class D license—the key to driving large commercial vehicles legally and safely.",
      headingForListing:
      "Class D License",
      subHeadingForListing:
      "Allows you to operate any truck or vehicle exceeding 11,000 kg (24,000 lbs) in gross weight, as well as tow trailers weighing up to 4,600 kg. Note : If you already hold a Class G license, you are eligible to apply for Class D training and take the required tests.",
    },
    vehicleTypeF: {
      headingText: "Class F License",
      headingText2:
      "Drive Commercial Passenger and Ambulance Vehicles. From Roads to Careers – Start Your Journey with Class F!",
      subHeading:
      "Are you looking to drive commercial passenger vehicles or operate an ambulance in Ontario? Vehicle Learning Innovation connects you with trusted MOT-approved training institutes that will help you obtain your Class F license with confidence.",
      headingForListing:
      "Class F License",
      subHeadingForListing:
      "Allows you to drive regular ambulances and vehicles designed to carry up to 24 passengers, including small buses and shuttle vans. This license is ideal for individuals looking to work in healthcare transport, shuttle services, or specialized transit operations. note: Before applying, you must hold a valid Ontario Class G or higher license and meet medical fitness requirements.",
    },
    vehicleTypeC: {
      headingText: "Class C License",
      headingText2:
      "Drive Heavy Commercial/ Buses Vehicles with Confidence. From Passenger Transport to Career Growth – The Class C License is Your Ticket to Success",
      subHeading:
      "Enrolling in an MOT-approved training program is the best way to prepare for your Class C license exam.",
      headingForListing:
      "Class C License",
      subHeadingForListing:
      "Class C license in Ontario allows you to operate large passenger vehicles, such as buses designed to carry more than 24 passengers. With this license, you can transport passengers safely and efficiently. Choose the Right Course and Get Licensed",
    },
    vehicleTypeA: {
      headingText: "Class A License ",
      headingText2:
      "Drive Heavy Commercial Vehicles / Trucks with Safety and Confidence! Your Gateway to a Professional Trucking / Commercial Career",
      subHeading:
      "At Vehicle Learning Innovation, we help aspiring truck drivers take the next step in their careers by connecting them with top-tier, government-approved training institutes.",
      headingForListing:
      "Class A License",
      subHeadingForListing:
      "Allows you to operate any truck-trailer combination, where the trailer’s gross weight exceeds 4,600 kg (10,000 lbs). This includes 18-wheelers, long-haul trucks, and heavy transport vehicles used for commercial freight. With this license. Find the best course and get a license.",
    },
    vehicleTypeE: {
      headingText: "Class E License",
      headingText2:
      "Your Gateway to a Professional Passenger Transport Career. Explore your options, get trained by certified professionals.",
      subHeading:
      "At Vehicle Learning Innovation, we bridge the gap between aspiring drivers and trusted, MOT-approved training institutes to help you obtain your Class E license with confidence.",
      headingForListing:
      "Class E License",
      subHeadingForListing:
      "Allows you to operate small school buses designed to carry up to 24 passengers. It also permits you to drive Class F vehicles, such as ambulances and other passenger transport vehicles including Class G Vehicle. If you’re passionate about ensuring safe and efficient transportation for students and passengers, this license is your pathway to a stable and respected career.",
    },

  }
;


export const DataForSubcategories = {
  licenseTypeG: {
    HeadingText : "G Class License ",
    HeadingText2 : "Explore, enroll, and drive with confidence!",
    SubHeading : "At Vehicle Learning Innovation, we simplify your path to obtaining a Class G license by connecting you with trusted, government-approved training institutes. Ontario follows a three-step graduated licensing system to ensure drivers gain the necessary experience and confidence before achieving full driving privileges. "  
  },
  licenseTypeM: {
    HeadingText : "Class M License – Your Path to Motorcycle & Motor Tricycle Freedom",
    HeadingText2 : "Master the Road on Two or Three Wheelers with Expert Training to Ride With Confidence",
    SubHeading : "At Vehicle Learning Innovation, we connect you with trusted training institutes to navigate Ontario’s motorcycle licensing system with confidence. From M1 beginners to full Class M riders, find the best courses to build safe and responsible riding skills."  
  },
  licenseTypeIndustrialMachinery: {
    HeadingText : "Industrial Machinery",
    HeadingText2 : "",
    SubHeading : "Heavy equipment operators operate heavy equipment used in the construction and maintenance of roads, bridges, airports, gas and oil pipelines, tunnels, buildings and other structures, in surface mining and quarrying activities and in material handling work. They are employed by construction, pipeline and logging companies, and by heavy equipment contractors."  
  }
       
}

export const DataForSubcategoriess = {
  licenseTypeG: {
    HeadingText : "Class G License – Full Privileges",
    headingText2:
      "Choose the Right Course Based on Your Goal",
    SubHeading : "If you want to obtain your full Class G license, We provide a variety of MOT-approved institutions to help you succeed with high quality training."  ,
    SecondSubHeading: "",
    ListingSecPara: "Allows you to drive cars, vans, and small trucks on all roads and highways in Ontario. For drivers under 21 years of age, some conditions still apply"
  },
  licenseTypeG1: {
    HeadingText : "Class G1 License  – The First Step",
    headingText2:
    "Take the first step Toward Your Driving Freedom!",
    SubHeading : "Starting your driving journey? Vehicle Learning Innovation helps you find the best training courses to prepare for your G1 test and gain essential driving knowledge..",
    SecondSubHeading: "",
    ListingSecPara: "G1 holders may drive Class G vehicles, but must be accompanied by a fully licensed driver with at least four years of driving experience.and restrictions on nighttime driving and high-speed roads. with certain restrictions."
  },
  licenseTypeG2: {
    HeadingText : "Class G2 License – Intermediate Stage ",
    headingText2:
      "Pass Your G2 Road Test with Expert, Government-Approved Training Institute",
    SubHeading : "With Vehicle Learning Innovation, you can enroll in expert-led courses designed to prepare you for the G2 road test. These programs provide in-depth knowledge of the G2 road test exam criteria used in Ontario.",
    SecondSubHeading: "",
    ListingSecPara : "Allows you to drive independently without the need for an accompanying driver. It grants access to all roads in Ontario, but certain conditions apply to drivers under 21."
  },
  licenseTypeM: {
    HeadingText : "Class M License  – Full Privileges",
    headingText2:
    "Start your journey and enjoy the open road with full privileges!",
    SubHeading : "At Vehicle Learning Innovation, we connect you with top government-approved training institutes to help you successfully obtain your Class M license. Choose the best course tailored to your needs, gain essential riding skills, and earn your full Class M license with confidence." ,
    SecondSubHeading : "",
    ListingSecPara: "You can ride on all roads and highways without restrictions. Riders under 21 years of age are still required to maintain a zero alcohol policy while operating a motorcycle. Select the Best Course to Match Your Motorcycle Licensing Stage."
  },
  licenseTypeM1: {
    HeadingText : "Class M1 License  – The First Step",
    headingText2:
    "Gear Up for the Road — Start Your M1 Journey Today",
    SubHeading : "Are you ready to ride, the Class M1 license is your first step toward driving freedom. With Vehicle Learning Innovation, you can access expert-led courses from MOT approved institutions that provide essential riding knowledge, safety training, and road test preparation.",
    SecondSubHeading : "",
    ListingSecPara: "A beginner permit that allows you to ride a motorcycle under certain restrictions, avoid highways with speeds over 80 km/h, and only ride during daylight hours. "
  },
  licenseTypeM2: {
    HeadingText : "Class M2 License  – Intermediate Stage",
    headingText2:
    "Take Your Riding Skills to the Next Level with expert Training",
    SubHeading : "Take the next step toward independent riding with the Class M2 license. Our partnered training institutes offer structured courses designed to prepare you for your M2 road test, equipping you with the skills needed for safe and responsible riding.",
    SecondSubHeading: "",
    ListingSecPara: "Grants more freedom, allowing you to ride without an accompanying driver, even at night and on all roads and highways in Ontario. Find the Perfect Training Course for Your Riding Goals"  
  },
  conditionL: {
    HeadingText : " Class M, M1, or M2 with Condition L (LSM/Moped) License",
    headingText2:
    "Ride Safely on Limited-Speed Motorcycles (LSM) & Mopeds",
    SubHeading : "If you hold an M, M1, or M2 license with Condition L, you are restricted to riding limited-speed motorcycles (LSM) or mopeds. These vehicles are designed for urban commuting with a maximum speed of 70 km/h.",
    SecondSubHeading: "",
    ListingSecPara: "Limited-speed motorcycles (LSM) or mopeds only. Limited-speed motorcycles are motorcycles with a maximum speed of 70 km/hr. If manufactured after 1988, they are identified by a label on the vehicle that indicates it to be a “LSM/MVL.” For a full description, visit MOT’s website" 
  },
  condition1: {
    HeadingText : "Class M, M1, or M2 with Condition 1 (Motor Tricycle) License",
    headingText2:
    "Experience the Thrill of Three-Wheeled Riding",
    SubHeading : "A Class M, M1, or M2 license with Condition 1 permits you to ride motor tricycles only. These vehicles provide a stable riding experience, making them an excellent choice for those seeking additional balance and safety on the road.",
    SecondSubHeading: "",
    ListingSecPara: "Motor tricycles (three-wheeled motorcycles) only. These vehicles travel on three wheels, have straddled seating, use a handle bar for steering, carry no more than 4 passengers, and have a gross vehicle weight of 1,000 kg or less. Some vehicles with three wheels, because of the close spacing of its front wheels, are considered to be a two-wheeled open motorcycle by Transport Canada. If you take a road test with one of these vehicles, you can get a full, rather than limited, M class driver’s licence." 
  }

 
       
}

